// eslint-disable-next-line snakecasejs/snakecasejs
export type FormDataObject = Record<string, string>;

export function formDataToObject( formData: FormData ): FormDataObject {
	const params: FormDataObject = {};

	formData.forEach( ( value, key ) => {
		params[key] = value.toString( ); // Convert all values to strings
	} );

	return params;
}
